import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

// Borrowed from https://blog.bitsrc.io/angular-maximizing-performance-with-the-intersection-observer-api-23d81312f178
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fromIntersectionObserver, IntersectionStatus } from './from-intersection-observer';

@Directive({
    selector: '[appIntersectionObserver]',
    standalone: true,
})
export class IntersectionObserverDirective implements OnInit, OnDestroy {
  @Input() intersectionDebounce = 0;
  @Input() intersectionRootMargin = '0px';
  @Input() intersectionRoot: HTMLElement;
  @Input() intersectionThreshold: number | number[];

  @Output() visibilityChange = new EventEmitter<IntersectionStatus>();

  private destroy$ = new Subject<void>();

  constructor(private element: ElementRef) {
  }

  ngOnInit() {
    const element = this.element.nativeElement;
    const config = {
      root: this.intersectionRoot || element.closest('.intersectionRoot'),
      rootMargin: this.intersectionRootMargin,
      threshold: this.intersectionThreshold,
    };

    fromIntersectionObserver(
        element,
        config,
        this.intersectionDebounce,
    ).pipe(
        takeUntil(this.destroy$),
    ).subscribe((status) => {
      this.visibilityChange.emit(status);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}